import { props, createAction } from '@ngrx/store';

import { DevAuthRequest } from '../../models/dev-auth-request.model';

export const sendAuthenticatedRequest = createAction(
  '[Dev-Auth] Submit Authenticated Request',
  props<DevAuthRequest>(),
);

export const sendAuthenticatedRequestSuccess = createAction(
  '[Dev-Auth] Authenticated Request Success',
  props<{ response: unknown }>(),
);
